<script>
import CharacterPortrait from '@/components/snippets/CharacterPortrait'
import Typewriter from '@/components/snippets/Typewriter'

import FastFade from '@/components/transitions/FastFade'

import dialogs from '@/config/dialogs'

export default {
  name: 'CharacterDialog',

  components: {
    CharacterPortrait,
    FastFade,
    Typewriter
  },

  props: {
    dialogSlug: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      currentLine: 0
    }
  },

  computed: {

    dialog () {
      return dialogs[this.dialogSlug]
    },

    canAdvance () {
      return !!this.dialog.lines[this.currentLine + 1]
    }

  },

  methods: {

    advanceLine () {
      this.currentLine++
    },

    onTypewriterComplete () {
      if (this.canAdvance) {
        setTimeout(this.advanceLine, 2000)
      }
    }

  }

}
</script>

<template>
  <div class="c-character-dialog">
    <div class="c-character-dialog-content">

      <div class="c-character-dialog-portrait">
        <fast-fade>
          <character-portrait
            :key="dialog.lines[currentLine].character"
            :character-slug="dialog.lines[currentLine].character"
          />
        </fast-fade>
      </div>

      <div class="c-character-dialog-lines">
        <fast-fade>
          <typewriter
            :key="currentLine"
            :message="dialog.lines[currentLine].text"
            @complete="onTypewriterComplete"
          />
        </fast-fade>
      </div>

    </div>
  </div>
</template>

<style lang="scss">

.c-character-dialog-content {
  @include flex;
  @include flex-center;
}

.c-character-dialog-portrait {
  @include flex-fixed;
  @include relative;
  @include push-pad-right;
  @include radius-loose;
  @include no-overflow;

  .c-character-portrait {
    width: 10rem !important;
    height: 10rem !important;
  }

}

.c-character-dialog-lines {
  @include flex-fluid;
}

</style>
